var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cog-field", class: "cog-col " + _vm.colNumClass },
    [
      _c("label", { staticClass: "cog-label", attrs: { for: _vm.fieldId } }, [
        _vm._v("\n\t\t" + _vm._s(_vm.label))
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }